<template>
  <div id="modalImportProductionOrder" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("rm.通过Excel导入生产订单") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <div class="form-group mg-b-60">
            <div
              class="
                alert alert-bordered alert-warning
                d-flex
                align-items-center
                justify-content-between
              "
              role="alert"
            >
              <div style="width: 70%; word-wrap: break-word">
                {{ $t("rm.请按照提供的模板Excel文件完善生产订单信息") }}
              </div>
              <a
                href="javascript:;"
                class="tx-info pos-absolute r-15"
                @click="downloadFile()"
                >{{ $t("distributor.下载Excel模板") }}</a
              >
            </div>
          </div>
          <div class="form-group mg-b-30">
            <label class="custom-file form-control-sm d-block">
              <input
                :placeholder="$t('distributor.请选择需要上传的导入文件')"
                @change="fileUpload($event)"
                type="file"
                id="upload_product"
                accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
              <span
                class="
                  custom-file-control custom-file-control-primary
                  form-control-sm
                  tx-ellipsis1
                "
                v-text="filePath"
              ></span>
            </label>
          </div>
          <div class="form-group mg-b-60">
            <p class="mg-b-10 tx-gray-900">
              1.{{ $t("product.请上传") }}.xls{{ $t("product.或") }}.xlsx{{
                $t("product.格式的文件。")
              }}
            </p>
            <p class="mg-b-10 tx-gray-900">
              2.{{ $t("distributor.Excel模板第一行标题请不要更改删除。") }}
            </p>
          </div>
          <div class="form-group tx-center">
            <button class="btn btn-primary" @click="confirmFileUpload">
              {{ $t("distributor.上传Excel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open"],
  data() {
    return {
      loading: false,
      inputSwitch: true,
      fileObj: "",
      filePath: "",
      lang: localStorage.getItem("ourmallVendorLang") || this.$i18n.locale,
    };
  },
  mounted() {
    $("#modalImportProductionOrder").on("hide.bs.modal", function () {
      $("#upload_product").attr("type", "text");
    });
  },
  watch: {
    open: function () {
      this.fileObj = "";
      this.filePath = "";
      $("#upload_product").attr("type", "file");
    },
  },
  methods: {
    fileUpload(el) {
      //文件上传
      let vm = this;
      vm.fileObj = el.target.files[0];
      vm.filePath = el.target.value;
    },
    confirmFileUpload() {
      if (!this.fileObj) {
        ShowTip(this.$t("distributor.请上传文件"), "danger");
        return;
      }
      let vm = this;
      vm.loading = true;
      vm.inputSwitch = false;
      let url;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      $.api_call(
        "api.Production.importProductionOrder",
        {
          "@file": vm.fileObj,
        },
        (r) => {
          vm.loading = false;
          vm.inputSwitch = true;
          if (r.ErrorCode == "9999") {
            $("#upload_product").attr("type", "text");
            $("#modalImportProductionOrder").modal("hide");
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            vm.$parent.getRMOrder();
            vm.$parent.getRMStatusNum();
            ShowTip(this.$t("rm.成功导入生产订单"), "success");
            url = r.Data.Results;
            openDownload(url);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    downloadFile() {
      let url = `/file/生产单导入模板-${this.lang}.xlsx`;
      if ($("#downloadFile").length == 0) {
        $("body").append(
          '<iframe id="downloadFile" style="display:none"></iframe>'
        );
      }
      let openDownload = (url) => {
        document.getElementById("downloadFile").src = url;
      };
      openDownload(url);
    },
  },
};
</script>